<template>
  <game-loading
    v-if="show"
    :game-version="version"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { GameLoading } from '@powerplay/core-minigames-ui'

export default defineComponent({
  name: 'LoadingComponent',
  components: { GameLoading },
  data() {

    return {
      show: true
    }

  },
  computed: {
    version() {

      return document.getElementById('live-layout')?.getAttribute('data-version') ?? ''

    }
  }
})
</script>
